module.exports = __webpack_public_path__ + "img/bg-cant-find_medium.f380bbaa.jpg";